import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { firebaseSignIn } from "./account/firebaseSignIn";
import { firebaseSignUp } from "./account/firebaseSignUp";
import { firebaseAdmin } from "./admin/firebaseAdmin";
import { isAdminHost } from "./admin/host";
import { warmUpAdmin } from "./admin/warmUp";
import { firebaseSessionCheck } from "./entry/session";
import { firebaseOnboarding } from "./onboarding/firebaseOnboarding";
import { firebaseProfile } from "./profile/firebaseProfile";
import { firebaseSettings } from "./settings/firebaseSettings";
import { preloadFirebase } from "./lib/firebaseModules";
import { paths, Router } from "./lib/router";
import { registerServiceWorker } from "./lib/serviceWorker";
import "./styles/index.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("#root is missing from index.html");
}

// SPEC-43: on the admin, its callables start waking before anything is drawn.
if (window.location.pathname === paths.admin || isAdminHost()) {
  warmUpAdmin();
}

createRoot(container).render(
  <StrictMode>
    <Router>
      <App
        checkSession={firebaseSessionCheck}
        signUp={firebaseSignUp}
        signIn={firebaseSignIn}
        onboarding={firebaseOnboarding}
        profile={firebaseProfile}
        admin={firebaseAdmin}
        settings={firebaseSettings}
      />
    </Router>
  </StrictMode>,
);

registerServiceWorker();
// Before the first tap on Criar conta or Entrar, while the page has just
// come over the network: a chunk that fails once stays failed until a reload.
preloadFirebase();
